var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasConfig == 'success')?_c('ww-open-data',{attrs:{"type":_vm.type,"openid":_vm.openid}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }